import { z } from 'zod';

export const globalSearchRequestSchema = z.object({
  Query: z.string().min(2),
  CurrentModuleCode: z.string(),
  CurrentEntityType: z.string(),
  CurrentVesselId: z.string().optional(),
  MaxResults: z.number().optional()
});

export type GlobalSearchRequest = z.infer<typeof globalSearchRequestSchema>;

export const globalSearchResultSchema = z.object({
  EntityType: z.string(),
  ModuleCode: z.string(),
  Id: z.string(),
  Label: z.string(),
  Breadcrumb: z.string(),
  BreadcrumbParts: z.array(z.string()),
  NavigationTarget: z.string(),
  ContextScore: z.number()
});

export type GlobalSearchResult = z.infer<typeof globalSearchResultSchema>;

export const globalSearchResponseSchema = z.object({
  Results: z.array(globalSearchResultSchema),
  TotalReturned: z.number(),
  ProvidersQueried: z.array(z.string()),
  ProvidersFailed: z.array(z.string())
});

export type GlobalSearchResponse = z.infer<typeof globalSearchResponseSchema>;
